import { useMemo } from 'react';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';

export function useShareOptions(): ShareActionsOptions {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	return useMemo(
		() => ({
			trackingEventName: 'share_news',
			getContent,
			getTrackingData,
		}),
		[getContent, getTrackingData],
	);
}
